import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { ParsedUrlDetails } from "types/pagination";
import { parseURLSearch } from "utils/urlUtil";

export default function useUrlSearchParams(): ParsedUrlDetails {
  const location = useLocation();
  return useMemo(() => parseURLSearch(location.search), [location.search]);
}
